import { render, staticRenderFns } from "./TextField2.vue?vue&type=template&id=de8f8b2a&scoped=true&"
import script from "./TextField2.vue?vue&type=script&lang=ts&"
export * from "./TextField2.vue?vue&type=script&lang=ts&"
import style0 from "./TextField2.vue?vue&type=style&index=0&id=de8f8b2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8f8b2a",
  null
  
)

export default component.exports